import React, { FormEvent, useState } from 'react';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';
import Appbar from 'components/appbar/Appbar';
import InsideSaving from 'components/loading/InsideSaving';
import {
  ContentPad,
  PageShell,
  RecordFooter,
  RecordHeader,
  StyledForm,
  WorkArea,
} from 'components/record-shell/RecordShell';
import { api } from 'services/api';
import history from 'services/history';
import { Specialty } from 'types/specialty';
import SpecialtyForm from '../form/SpecialtyForm';

const NewSpecialty: React.FC = () => {
  const [validation, setValidation] = useState('');
  const [saving, setSaving] = useState(false);
  const [specialty, setSpecialty] = useState<Specialty>({
    id: 0,
    name: '',
  });

  function goBack() {
    history.push('/specialties');
  }

  function handleChange<K extends keyof Specialty>(index: K, value: Specialty[K]) {
    setSpecialty(prev => ({ ...prev, [index]: value }));
  }

  function handleSubmit() {
    setSaving(true);

    api
      .post('/specialties', specialty)
      .then(response => {
        toast.success('Especialidade cadastrada');
        // abre a especialidade recém-cadastrada
        history.push(response.data?.id ? `/specialties/${response.data.id}` : '/specialties');
      })
      .catch(err => {
        toast.error(err.response?.data?.error || 'Não foi possível cadastrar a especialidade');
      })
      .finally(() => setSaving(false));
  }

  function handleValidation(e?: FormEvent<HTMLFormElement>) {
    e?.preventDefault();
    setValidation('');
    if (!specialty.name) {
      setValidation('Nome é obrigatório');
      return;
    }
    handleSubmit();
  }

  return (
    <>
      <Appbar title="Especialidades" backAction={goBack} />

      {saving && <InsideSaving />}

      <PageShell>
        <RecordHeader title="Nova especialidade" backAction={goBack} />

        <WorkArea>
          <ContentPad>
            <StyledForm onSubmit={handleValidation}>
              <SpecialtyForm handleChange={handleChange} specialty={specialty} validation={validation} />
              <button type="submit" style={{ display: 'none' }}></button>
            </StyledForm>
          </ContentPad>
        </WorkArea>

        <RecordFooter>
          <Button variant="contained" size="small" disabled={saving} onClick={() => handleValidation()}>
            Salvar especialidade
          </Button>
        </RecordFooter>
      </PageShell>
    </>
  );
};

export default NewSpecialty;
